import { render, staticRenderFns } from "./bankManagement.vue?vue&type=template&id=0d270976&"
import script from "./bankManagement.vue?vue&type=script&lang=js&"
export * from "./bankManagement.vue?vue&type=script&lang=js&"
import style0 from "./bankManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports